import { AccountCreate } from "./AccountCreate";
import { AccountList } from "./AccountList";
import { AccountShow } from "./AccountShow";
import { CompanyEdit } from "./CompanyEdit";

export default {
  list: AccountList,
  create: AccountCreate,
  edit: CompanyEdit,
  show: AccountShow,
};
